import React from 'react'
import { FormattedMessage } from 'react-intl'

interface props {
  color?: string
}

export const OpenBadge = ({ color }: props) => (
  <div
    className="mb-3 inline-flex h-6 items-center rounded-xl border border-current px-2 uppercase my-label-xs"
    style={{
      color: color || '#48BC91',
    }}
  >
    <span>
      <FormattedMessage defaultMessage="Open now" id="AbmghR" />
    </span>
  </div>
)

export const ClosedBadge = ({ color }: props) => (
  <div
    className="mb-3 inline-flex h-6 items-center rounded-xl px-2 uppercase my-label-xs"
    style={{
      color: color || '#F04E63',
      backgroundColor: '#FFE6E9',
    }}
  >
    <span>
      <FormattedMessage defaultMessage="Closed" id="Fv1ZSz" />
    </span>
  </div>
)
